import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import "assets/scss/style.scss";
import "assets/theme/theme.scss";
import "bootstrap-icons/font/bootstrap-icons.css";
import { ErrorBoundary } from "components/shared";


ReactDOM.render(<ErrorBoundary><App /> </ErrorBoundary>, document.getElementById('root'));
